module.exports = __webpack_public_path__ + "static/interstate-bold-condensed-ee8799184a43c89d8586baf1fa1affc5.woff";